<template>
  <div id="page">
    <img
      :src="images.top"
      style="width: 100%; float: center; margin-top: 40px"
    />

    <div id="title-one">人才盘点测评报告</div>
    <!-- <div id="title-two"  v-if="this.isMemberEnterpriseTeam === false">
      {{ this.model.departmentName }}
    </div> -->
    <div id="title-two">一、背景信息</div>
    <div style="margin-left: 60px">
      <table
        border="1"
        width="674"
        class="table-info3"
        style="margin-top: 10px"
      >
        <tr border="1" width="674" height="50px">
          <td colspan="2">
            <span class="et3"
              ><b style="color: #9e9e9e;"
                >姓名
                </b
              ><b>{{ this.model.name }}</b></span
            >
          </td>
        </tr>
        <tr border="1" width="674" height="50px">
          <td >
            <span class="et3">
              <b style="color: #9e9e9e">排名</b
              >
              <b >{{ this.rank }}</b>
            </span>
          </td>
          <td >
            <span class="et3">
              <b style="color: #9e9e9e">推荐等级</b
              >
              <b>{{ this.recommendRank }}</b>
            </span>
          </td>
        </tr>
        <tr border="1" width="674" height="50px">
          <td >
            <span class="et3">
              <b style="color: #9e9e9e">所在项目</b
              >
              <b>{{ this.project }}</b>
            </span>
          </td>
          <td >
            <span class="et3">
              <b style="color: #9e9e9e">担任职务</b
              >
              <b >{{ this.duty }}</b>
            </span>
          </td>
        </tr>
        <tr border="1" width="674" height="50px">
          <td >
            <span class="et3">
              <b style="color: #9e9e9e">年龄</b
              >
              <b>{{ this.age }}</b>
            </span>
          </td>
          <td >
            <span class="et3">
              <b style="color: #9e9e9e">司龄</b
              >
              <b>{{ this.companyAge }}</b>
            </span>
          </td>
        </tr>
<!--        <tr border="1" width="674" height="50px">-->
<!--          <td >-->
<!--            <span class="et3">-->
<!--              <b style="color: #9e9e9e">最高学历&nbsp;&nbsp;&nbsp;</b-->
<!--              >-->
<!--              <b></b>-->
<!--            </span>-->
<!--          </td>-->
<!--          <td >-->
<!--            <span class="et3">-->
<!--              <b style="color: #9e9e9e">专业技术资格&nbsp;&nbsp;&nbsp;</b-->
<!--              >-->
<!--              <b></b>-->
<!--            </span>-->
<!--          </td>-->
<!--        </tr>-->
        <!-- <tr border="1" width="674">
          <td width="220" class="et3">
            <b style="color: #9e9e9e">性别</b><br /><b>{{
              this.sex || " "
            }}</b>
          </td>
          <td width="220" class="et3">
            <b style="color: #9e9e9e">出生年月</b><br />
            <b>{{ this.birthday || " " }}</b>
          </td>
          <td width="244" class="et3">
            <b style="color: #9e9e9e">学历学位</b><br />
            <b>{{ this.degree || " " }}</b>
          </td>
        </tr>

        <tr border="1" width="674">
          <td width="220" class="et3" v-if="this.departmentName && this.isMemberEnterpriseTeam === false" >
            <b style="color: #9e9e9e">部门</b><br />
            <b>{{ this.departmentName || " " }}</b>
          </td>
          <td width="220" class="et3" v-if="this.departmentName==='' && this.level==='' " colspan="3">
            <b style="color: #9e9e9e">现任职务</b><br /><b>{{
              this.job || " "
            }}</b>
          </td>
             <td width="220" class="et3"  v-if="this.departmentName!=='' && this.level!==''" >
            <b style="color: #9e9e9e">现任职务</b><br /><b>{{
              this.job || " "
            }}</b>
          </td>

          <td width="224" class="et3" v-if="this.level && this.isMemberEnterpriseTeam === true" colspan="2" >
            <b style="color: #9e9e9e">层级</b><br /><b>{{
              this.level || " "
            }}</b>
          </td>
          <td width="224" class="et3" v-if="this.level && this.isMemberEnterpriseTeam === false ">
            <b style="color: #9e9e9e">层级</b><br /><b>{{
              this.level || " "
            }}</b>
          </td>
        </tr> -->
      </table>
    </div>
    <div id="title-two">二、综合能力测试</div>
    <div style="margin: 18px 60px 0 60px;">
     <b>1、综合能力分析</b>
    </div>
    <barline-charts :xAxisData="xAxisData" :barData="barData" :lineData="lineData" :name="name"/>
    <div v-if="type==='正职后备'" style="margin: 18px 60px 0 60px; line-height: 30px; text-indent: 30px;font-size: 13px;">
      <table border="1" width="674" style="border-collapse: collapse;">
          <tr>
            <td style="height: 60px;text-align: center; font-weight: 600;" rowspan="2" width="90px">评价指标</td>
            <td style="height: 60px;text-align: center; font-weight: 600;" colspan="3" width="120px">管理业务（45%）</td>
            <td style="height: 60px;text-align: center; font-weight: 600;" colspan="3" >管理团队（30%）</td>
            <td style="height: 60px;text-align: center; font-weight: 600;" colspan="2">管理自我（25%）</td>
            <td style="height: 60px;text-align: center; font-weight: 600;" rowspan="2" >加权总分</td>
          </tr>

          <tr>
            <td class="et2">分析决策</td>
            <td class="et2">资源统筹</td>
            <td class="et2">项目管理</td>
            <td class="et2">领导团队</td>
            <td class="et2">知人善用</td>
            <td class="et2">人际影响</td>
            <td class="et2">责任担当</td>
            <td class="et2">绩效导向</td>
          </tr>
          <tr>
            <td class="et2">个人得分</td>
            <td class="et2" style="font-weight: bold">{{ s1 }}</td>
            <td class="et2" style="font-weight: bold">{{ s2 }}</td>
            <td class="et2" style="font-weight: bold">{{ s3 }}</td>
            <td class="et2" style="font-weight: bold">{{ s4 }}</td>
            <td class="et2" style="font-weight: bold">{{ s5 }}</td>
            <td class="et2" style="font-weight: bold">{{ s6 }}</td>
            <td class="et2" style="font-weight: bold">{{ s7 }}</td>
            <td class="et2" style="font-weight: bold">{{ s8 }}</td>
            <td class="et2" style="font-weight: bold">{{ s9 }}</td>
          </tr>
          <tr>
            <td class="et2">均分</td>
            <td class="et2" style="font-weight: bold">{{ s1avg }}</td>
            <td class="et2" style="font-weight: bold">{{ s2avg }}</td>
            <td class="et2" style="font-weight: bold">{{ s3avg }}</td>
            <td class="et2" style="font-weight: bold">{{ s4avg }}</td>
            <td class="et2" style="font-weight: bold">{{ s5avg }}</td>
            <td class="et2" style="font-weight: bold">{{ s6avg }}</td>
            <td class="et2" style="font-weight: bold">{{ s7avg }}</td>
            <td class="et2" style="font-weight: bold">{{ s8avg }}</td>
            <td class="et2" style="font-weight: bold">{{ s9avg }}</td>
          </tr>
        </table>
    </div>
    <div v-if="type==='副职后备'" style="margin: 18px 60px 0 60px; line-height: 30px; text-indent: 30px;font-size: 13px;">
          <table border="1" width="674" style="border-collapse: collapse;">
              <tr>
                  <td style="height: 60px;text-align: center; font-weight: 600;" rowspan="2" width="90px">评价指标</td>
                  <td style="height: 60px;text-align: center; font-weight: 600;" colspan="3" width="120px">管理业务（45%）</td>
                  <td style="height: 60px;text-align: center; font-weight: 600;" colspan="3" >管理团队（30%）</td>
                  <td style="height: 60px;text-align: center; font-weight: 600;" colspan="2">管理自我（25%）</td>
                  <td style="height: 60px;text-align: center; font-weight: 600;" rowspan="2" >加权总分</td>
              </tr>

              <tr>
                  <td class="et2">分析判断</td>
                  <td class="et2">全局观念</td>
                  <td class="et2">计划执行</td>
                  <td class="et2">沟通协调</td>
                  <td class="et2">培养指导</td>
                  <td class="et2">人际交往</td>
                  <td class="et2">责任担当</td>
                  <td class="et2">积极进取</td>
              </tr>
              <tr>
                  <td class="et2">个人得分</td>
                  <td class="et2" style="font-weight: bold">{{ s1 }}</td>
                  <td class="et2" style="font-weight: bold">{{ s2 }}</td>
                  <td class="et2" style="font-weight: bold">{{ s3 }}</td>
                  <td class="et2" style="font-weight: bold">{{ s4 }}</td>
                  <td class="et2" style="font-weight: bold">{{ s5 }}</td>
                  <td class="et2" style="font-weight: bold">{{ s6 }}</td>
                  <td class="et2" style="font-weight: bold">{{ s7 }}</td>
                  <td class="et2" style="font-weight: bold">{{ s8 }}</td>
                  <td class="et2" style="font-weight: bold">{{ s9 }}</td>
              </tr>
              <tr>
                  <td class="et2">均分</td>
                  <td class="et2" style="font-weight: bold">{{ s1avg }}</td>
                  <td class="et2" style="font-weight: bold">{{ s2avg }}</td>
                  <td class="et2" style="font-weight: bold">{{ s3avg }}</td>
                  <td class="et2" style="font-weight: bold">{{ s4avg }}</td>
                  <td class="et2" style="font-weight: bold">{{ s5avg }}</td>
                  <td class="et2" style="font-weight: bold">{{ s6avg }}</td>
                  <td class="et2" style="font-weight: bold">{{ s7avg }}</td>
                  <td class="et2" style="font-weight: bold">{{ s8avg }}</td>
                  <td class="et2" style="font-weight: bold">{{ s9avg }}</td>
              </tr>
          </table>
      </div>
    <div v-if="type==='青年人才'" style="margin: 18px 60px 0 60px; line-height: 30px; text-indent: 30px;font-size: 13px;">
          <table border="1" width="674" style="border-collapse: collapse;">
              <tr>
                  <td style="height: 60px;text-align: center; font-weight: 600;" rowspan="2" width="90px">评价指标</td>
                  <td style="height: 60px;text-align: center; font-weight: 600;" colspan="3" width="120px">任务落实（45%）</td>
                  <td style="height: 60px;text-align: center; font-weight: 600;" colspan="3" >协同他人（30%）</td>
                  <td style="height: 60px;text-align: center; font-weight: 600;" colspan="2">自我驱动（25%）</td>
                  <td style="height: 60px;text-align: center; font-weight: 600;" rowspan="2" >加权总分</td>
              </tr>

              <tr>
                  <td class="et2">分析判断</td>
                  <td class="et2">目标管理</td>
                  <td class="et2">学习创新</td>
                  <td class="et2">资源协同</td>
                  <td class="et2">团队精神</td>
                  <td class="et2">人际沟通</td>
                  <td class="et2">组织认同</td>
                  <td class="et2">积极进取</td>
              </tr>
              <tr>
                  <td class="et2">个人得分</td>
                  <td class="et2" style="font-weight: bold">{{ s1 }}</td>
                  <td class="et2" style="font-weight: bold">{{ s2 }}</td>
                  <td class="et2" style="font-weight: bold">{{ s3 }}</td>
                  <td class="et2" style="font-weight: bold">{{ s4 }}</td>
                  <td class="et2" style="font-weight: bold">{{ s5 }}</td>
                  <td class="et2" style="font-weight: bold">{{ s6 }}</td>
                  <td class="et2" style="font-weight: bold">{{ s7 }}</td>
                  <td class="et2" style="font-weight: bold">{{ s8 }}</td>
                  <td class="et2" style="font-weight: bold">{{ s9 }}</td>
              </tr>
              <tr>
                  <td class="et2">均分</td>
                  <td class="et2" style="font-weight: bold">{{ s1avg }}</td>
                  <td class="et2" style="font-weight: bold">{{ s2avg }}</td>
                  <td class="et2" style="font-weight: bold">{{ s3avg }}</td>
                  <td class="et2" style="font-weight: bold">{{ s4avg }}</td>
                  <td class="et2" style="font-weight: bold">{{ s5avg }}</td>
                  <td class="et2" style="font-weight: bold">{{ s6avg }}</td>
                  <td class="et2" style="font-weight: bold">{{ s7avg }}</td>
                  <td class="et2" style="font-weight: bold">{{ s8avg }}</td>
                  <td class="et2" style="font-weight: bold">{{ s9avg }}</td>
              </tr>
          </table>
      </div>
    <div id="footer">
      <span id="footer-red"
        >1</span
      >
    </div>
  </div>
</template>

<script>
import capability1 from "@/components/dataView/echarts/four/capability1.vue";
import barlineCharts from './barlineCharts.vue'
export default {
  props: ["model", "employeeInfos", "evaluate", "avg", "result", "TaScore","isMemberEnterpriseTeam"],
  components: { capability1,barlineCharts },
  data() {
    return {
      rank: "",
      recommendRank: "",
      project: "",
      duty: "",
      age:"",
      companyAge:"",
      type:"",
      job: "",
      level: "",
      maxName: "",
      maxScore: "",
      middleName: "",
      middleScore: "",
      middle2Name: "",
      middle2Score: "",

      minName: "",
      minScore: "",

      score1: 0,
      compareResult: "",
      titleLine: [],
      title1: "",
      good1: [],
      bad1: [],
      title2: "",
      good2: [],
      bad2: [],
      title3: "",
      good3: [],
      bad3: [],
      title4: "",
      good4: [],
      bad4: [],
      name: "",
      results: [],
      len: 0,

      s1:"",
      s2:"",
      s3:"",
      s4:"",
      s5:"",
      s6:"",
      s7:"",
      s8:"",
      s9:"",

      s1avg:"",
      s2avg:"",
      s3avg:"",
      s4avg:"",
      s5avg:"",
      s6avg:"",
      s7avg:"",
      s8avg:"",
      s9avg:"",
      xAxisData: [],
      barData: [],
      lineData: [],
      images: {
        top: require("@/views/CNBMTalent/images/top.jpg"),
      },
    };
  },
  mounted() {
    if (this.avg.length != 0) {
      this.loadData();
    }
  },
  watch: {
    employeeInfos(val) {
      this.loadData();
    },
    evaluate(val) {
      if (val) {
        this.loadData();
        this.handleResult();
      }
    },
  },
  methods: {
    loadData() {
      let dataKey = [];
      let avgKey = [];
      let dataArr = [];
      let avgArr = [];
      this.name = this.model.name;
      this.employeeInfos.map((item) => {
        if (item.key == "排名") {
          this.rank = item.value;
        }
        if (item.key == "推荐等级") {
          this.recommendRank = item.value;
        }
        if (item.key == "所在项目") {
          this.project = item.value;
        }
        if (item.key == "担任职务") {
          this.duty = item.value;
        }
        if (item.key == "年龄") {
          this.age = item.value;
        }
        if (item.key == "司龄") {
          this.companyAge = item.value;
        }
        if(item.key === '类型'){
          this.type = item.value;
        }
      });
        if(this.type === '正职后备'){
            dataKey= ["分析决策","资源统筹","项目管理","领导团队","知人善用","人际影响","责任担当","绩效导向","总分"]
            avgKey= ["分析决策平均分","资源统筹平均分","项目管理平均分","领导团队平均分","知人善用平均分","人际影响平均分","责任担当平均分","绩效导向平均分","总分平均分"]
    
            this.employeeInfos.map((item) => {
                if(dataKey.indexOf(item.key) != -1) {
                  dataArr.push(item.value)
                }
                if(avgKey.indexOf(item.key) != -1) {
                  avgArr.push(item.value)
                }

                if (item.key === '分析决策') {
                    this.s1 = item.value;
                }
                if (item.key === '资源统筹') {
                    this.s2 = item.value;
                }
                if (item.key === '项目管理') {
                    this.s3 = item.value;
                }
                if (item.key === '领导团队') {
                    this.s4 = item.value;
                }
                if (item.key === '知人善用') {
                    this.s5 = item.value;
                }
                if (item.key === '人际影响') {
                    this.s6 = item.value;
                }
                if (item.key === '责任担当') {
                    this.s7 = item.value;
                }
                if (item.key === '绩效导向') {
                    this.s8 = item.value;
                }
                if (item.key === '总分') {
                    this.s9 = item.value;
                }

                if (item.key === '分析决策平均分') {
                    this.s1avg = item.value;
                }
                if (item.key === '资源统筹平均分') {
                    this.s2avg = item.value;
                }
                if (item.key === '项目管理平均分') {
                    this.s3avg = item.value;
                }
                if (item.key === '领导团队平均分') {
                    this.s4avg = item.value;
                }
                if (item.key === '知人善用平均分') {
                    this.s5avg = item.value;
                }
                if (item.key === '人际影响平均分') {
                    this.s6avg = item.value;
                }
                if (item.key === '责任担当平均分') {
                    this.s7avg = item.value;
                }
                if (item.key === '绩效导向平均分') {
                    this.s8avg = item.value;
                }
                if (item.key === '总分平均分') {
                    this.s9avg = item.value;
                }
            })
        }else if(this.type === '副职后备'){
            dataKey= ["分析判断","全局观念","计划执行","沟通协调","培养指导","人际交往","责任担当","积极进取","总分"]
            avgKey= ["分析判断平均分","全局观念平均分","计划执行平均分","沟通协调平均分","培养指导平均分","人际交往平均分","责任担当平均分","积极进取平均分","总分平均分"]

            this.employeeInfos.map((item) => {
                if(dataKey.indexOf(item.key) != -1) {
                  dataArr.push(item.value)
                }
                if(avgKey.indexOf(item.key) != -1) {
                  avgArr.push(item.value)
                }

                if (item.key === '分析判断') {
                    this.s1 = item.value;
                }
                if (item.key === '全局观念') {
                    this.s2 = item.value;
                }
                if (item.key === '计划执行') {
                    this.s3 = item.value;
                }
                if (item.key === '沟通协调') {
                    this.s4 = item.value;
                }
                if (item.key === '培养指导') {
                    this.s5 = item.value;
                }
                if (item.key === '人际交往') {
                    this.s6 = item.value;
                }
                if (item.key === '责任担当') {
                    this.s7 = item.value;
                }
                if (item.key === '积极进取') {
                    this.s8 = item.value;
                }
                if (item.key === '总分') {
                    this.s9 = item.value;
                }

                if (item.key === '分析判断平均分') {
                    this.s1avg = item.value;
                }
                if (item.key === '全局观念平均分') {
                    this.s2avg = item.value;
                }
                if (item.key === '计划执行平均分') {
                    this.s3avg = item.value;
                }
                if (item.key === '沟通协调平均分') {
                    this.s4avg = item.value;
                }
                if (item.key === '培养指导平均分') {
                    this.s5avg = item.value;
                }
                if (item.key === '人际交往平均分') {
                    this.s6avg = item.value;
                }
                if (item.key === '责任担当平均分') {
                    this.s7avg = item.value;
                }
                if (item.key === '积极进取平均分') {
                    this.s8avg = item.value;
                }
                if (item.key === '总分平均分') {
                    this.s9avg = item.value;
                }
            })
           
        }else if (this.type === '青年人才'){
            dataKey= ["分析判断","目标管理","学习创新","资源协同","团队精神","人际沟通","组织认同","积极进取","总分"]
            avgKey= ["分析判断平均分","目标管理平均分","学习创新平均分","资源协同平均分","团队精神平均分","人际沟通平均分","组织认同平均分","积极进取平均分","总分平均分"]
            this.employeeInfos.map((item) => {
                if(dataKey.indexOf(item.key) != -1) {
                  dataArr.push(item.value)
                }
                if(avgKey.indexOf(item.key) != -1) {
                  avgArr.push(item.value)
                }
                if (item.key === '分析判断') {
                    this.s1 = item.value;
                }
                if (item.key === '目标管理') {
                    this.s2 = item.value;
                }
                if (item.key === '学习创新') {
                    this.s3 = item.value;
                }
                if (item.key === '资源协同') {
                    this.s4 = item.value;
                }
                if (item.key === '团队精神') {
                    this.s5 = item.value;
                }
                if (item.key === '人际沟通') {
                    this.s6 = item.value;
                }
                if (item.key === '组织认同') {
                    this.s7 = item.value;
                }
                if (item.key === '积极进取') {
                    this.s8 = item.value;
                }
                if (item.key === '总分') {
                    this.s9 = item.value;
                }

                if (item.key === '分析判断平均分') {
                    this.s1avg = item.value;
                }
                if (item.key === '目标管理平均分') {
                    this.s2avg = item.value;
                }
                if (item.key === '学习创新平均分') {
                    this.s3avg = item.value;
                }
                if (item.key === '资源协同平均分') {
                    this.s4avg = item.value;
                }
                if (item.key === '团队精神平均分') {
                    this.s5avg = item.value;
                }
                if (item.key === '人际沟通平均分') {
                    this.s6avg = item.value;
                }
                if (item.key === '组织认同平均分') {
                    this.s7avg = item.value;
                }
                if (item.key === '积极进取平均分') {
                    this.s8avg = item.value;
                }
                if (item.key === '总分平均分') {
                    this.s9avg = item.value;
                }
            })
        }
        this.barData = dataArr;
        this.lineData = avgArr;
        this.xAxisData = dataKey;

      // let len = this.avg.length;
      // this.avg.map((item) => {
      //   if (item.level == "自评") {
      //     this.score1 = item.score;
      //   }
      // });
      // if (parseFloat(this.score1) > parseFloat(this.TaScore)) {
      //   this.compareResult = "高";
      // } else if (parseFloat(this.score1) == parseFloat(this.TaScore)) {
      //   this.compareResult = "等";
      // } else {
      //   this.compareResult = "低";
      // }
      // if(this.avg.length === 3){
      //   this.maxScore = this.avg[0].score;
      //   this.maxName = this.avg[0].level;
      //   this.middleScore = this.avg[1].score;
      //   this.middleName = this.avg[1].level;
      //   this.minName = this.avg[2].level;
      //   this.minScore = this.avg[2].score;
      // }

      //  if(this.avg.length === 2){
      //   this.maxScore = this.avg[0].score;
      //   this.maxName = this.avg[0].level;
      //   this.minName = this.avg[1].level;
      //   this.minScore = this.avg[1].score;
      // }

      //   if(this.avg.length === 1){
      //   this.maxScore = this.avg[0].score;
      //   this.maxName = this.avg[0].level;
      // }

      // if (this.avg.length > 3) {
      //   this.maxScore = this.avg[0].score;
      //   this.maxName = this.avg[0].level;
      //   this.middleScore = this.avg[1].score;
      //   this.middleName = this.avg[1].level;
      //   this.middle2Name = this.avg[2].level;
      //   this.middle2Score = this.avg[2].score;
      //   this.minName = this.avg[3].level;
      //   this.minScore = this.avg[3].score;
      // } else {
      //   this.maxScore = this.avg[0].score;
      //   this.maxName = this.avg[0].level;

      //   if(this.avg.length > 1)
      //   this.middleScore = this.avg[0].score;
      //   this.middleName = this.avg[0].level;

      //   if (this.avg.length > 2) {
      //     this.minName = this.avg[2].level;
      //     this.minScore = this.avg[2].score;
      //   }
      // }
    },
    handleResult() {
      // this.result.map((item) => {
      //   if (item.level === "自评") {
      //     this.results.push(item);
      //   } else if (item.level === "他评") {
      //     this.results.push(item);
      //   } else {
      //     return;
      //   }
      // });
    },
  },
};
</script>
<style lang='scss' scoped>
  .title {
    padding-top: 30px;
    text-align: center;
    font-size: 22px;
    font-weight: bold;
    font-weight: bold;
    font-size: 25px;
  }
  .title-two {
    font-size: 22px;
    font-weight: bold;
    margin: 10px 60px 0 60px;
  }
  .content-info {
    margin: 10px 60px 0 60px;
    line-height: 30px;
    text-indent: 30px;
  }
  .table-info3 {
    border: 2px solid #a1a1a1;
    border-spacing: 10px;
    border-collapse: collapse;
    font-size: 17px;
    width: 674px;
  }
  .table-info {
    border: 2px solid #a1a1a1;
    border-spacing: 10px;
    border-collapse: collapse;
  }
  .table-info1 {
    border: 1px solid #a1a1a1;
    border-spacing: 10px;
    border-collapse: collapse;
    border-left: none;
  }
  .note-info {
    text-align: right;
    font-size: 10px;
    margin-right: 70px;
    color: #6e7079;
  }
  .et2 {
    vertical-align: middle;
    font-weight: bold;
    text-align: center;
    padding: 3px;
  }
  .et3 {
    vertical-align: left;
    // font-weight: bold;
    text-align: left;
    padding: 10px;
  }
  .et3 b:first-child {
    width: 73px;
    display: inline-block;
    text-align: justify;
    text-align-last: justify;
  }
  .et3 b:last-child {
    margin-left: 8px;
  }
  #footer {
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 60px; /*脚部的高度*/
    text-align: center;
    clear: both;
  }

</style>



// WEBPACK FOOTER //
// src/views/CNBMTalent/pages/page-two.vue